import { AddToBlacklistDto } from '../../../dto/addtoblacklist/addtoblacklistdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface AddToBlacklistRequest extends APIRequest
{
    getAddToBlacklistRequest(): AddToBlacklistDto;
}

export class AddToBlacklistRequestImpl extends APIRequestDtoImpl implements AddToBlacklistRequest
{
    constructor(private addToBlacklistData: AddToBlacklistDto)
    {
        super();
    }

    getAddToBlacklistRequest(): AddToBlacklistDto
    {
        return this.addToBlacklistData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/blacklist/addtoblacklist/addtoblacklistrequest.tsx